import {Component, Input} from '@angular/core';
import {Belastungsstufe, Tendenz} from '../../../../../../../../model/vorhersagen/pollenflug';

@Component({
  selector: 'app-pollenflug-tag',
  templateUrl: './pollenflug-tag.component.html',
  styleUrls: ['./pollenflug-tag.component.css']
})
export class PollenflugTagComponent {

  @Input()
  header: string;
  @Input()
  belastungsstufe: Belastungsstufe;
  @Input()
  tendenz: Tendenz;

}
